import React, { useState, useEffect } from 'react'
import TysiaButtonWithText from 'design-system/TysiaButtonWithText/index.js'
import TysiaText from '../TysiaText/index.js'

export default function ClearFiltersStatusPanel(props) {
  let [hasFilters, setHasFilters] = useState(false)

  useEffect(() => {
    if (!props.api) return

    updateFilterState()
    props.api.addEventListener('filterChanged', updateFilterState)
    return () => {
      if (props.api) {
        props.api.removeEventListener('filterChanged', updateFilterState)
      }
    }

    function updateFilterState() {
      let filterModel = props.api.getFilterModel()
      setHasFilters(Object.keys(filterModel || {}).length > 0)
    }
  }, [props.api])

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
      {hasFilters && (
        <>
          <TysiaText
            viewPath="/App/TysiaText"
            text="Not seeing the data you want?"
            size="small"
            marginRight={4}
          />
          <TysiaButtonWithText
            viewPath="/App/TysiaButtonWithText"
            onClick={onClick}
            type="primary"
            size="small"
            text="Clear all filters"
          />
        </>
      )}
    </div>
  )
  function onClick() {
    if (props.api) {
      props.api.setFilterModel(null)
      props.api.onFilterChanged()
    }
  }
}
